/**
 * Keep sold-out products at the end of the collection grid.
 * Runs on default sort only so customer-selected sorts stay intact.
 * Works with infinite scroll by re-sorting the full grid after each append.
 */
(function () {
  const SOLD_OUT_SELECTOR = 'product-card.product-card__sold-out, .product-card.product-card__sold-out';

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function shouldApply(grid) {
    if (!grid || grid.dataset.oosLast !== 'true') return false;

    const defaultSort = grid.dataset.defaultSort || '';
    const sortBy = new URLSearchParams(window.location.search).get('sort_by');

    return !sortBy || sortBy === defaultSort;
  }

  function sortOutOfStockLast(grid) {
    const target = grid || getGrid();
    if (!shouldApply(target)) return;

    const children = Array.from(target.children);
    if (!children.length) return;

    const available = [];
    const soldOut = [];

    children.forEach((child) => {
      if (child.matches(SOLD_OUT_SELECTOR)) {
        soldOut.push(child);
      } else {
        available.push(child);
      }
    });

    if (!soldOut.length) return;

    // Avoid DOM thrashing when already sorted
    const lastAvailableIndex = available.length
      ? children.indexOf(available[available.length - 1])
      : -1;
    const firstSoldOutIndex = children.indexOf(soldOut[0]);
    if (firstSoldOutIndex > lastAvailableIndex && soldOut.length === children.length - available.length) {
      const alreadySorted = soldOut.every((el, i) => children[available.length + i] === el);
      if (alreadySorted) return;
    }

    const fragment = document.createDocumentFragment();
    available.forEach((el) => fragment.appendChild(el));
    soldOut.forEach((el) => fragment.appendChild(el));
    target.appendChild(fragment);
  }

  window.themeCollectionAvailability = {
    sortGrid: sortOutOfStockLast
  };

  document.addEventListener('DOMContentLoaded', () => {
    sortOutOfStockLast();
  });

  document.addEventListener('shopify:section:load', () => {
    sortOutOfStockLast();
  });

  document.addEventListener('filter:updated', () => {
    sortOutOfStockLast();
  });
})();
